<template>
	<div class="page-login">
		<form method="POST" class="form-login" @submit.prevent="login">
			<fieldset class="login-container">
				<input
					aria-label="Email o Usuario"
					class="form-input mb-10"
					placeholder="Email o Usuario"
					name="email"
					type="email"
					v-model="email"
				/>
				<input
					aria-label="Contraseña"
					class="form-input mb-10"
					ref="password"
					placeholder="Contraseña"
					name="password"
					type="password"
					v-model="password"
				/>
				<div class="form-row text-center">
					<button
						class="btn btn-blue"
						:disabled="isLoading"
						type="submit"
						@click="login"
					>
						Iniciar Sesión
					</button>
				</div>
			</fieldset>
		</form>
	</div>
</template>

<script>
	import helper from '@/shared/helper';

	function created() {
		window.localStorage.clear();
	}

	async function login() {
		window.localStorage.clear();
		this.isLoading = true;
		const userData = {
			email: this.email,
			password: this.password,
			codeApp: process.env.APP_CODE,
		};
		try {
			const response = await this.$httpAcl.post('authenticate', userData);
			const user = response.data;
			const { token, codeProject } = user;
			helper.setLocalData(user);
			helper.setLocalData(codeProject, 'codeProject');
			helper.setLocalData(token, 'token');
			helper.setLocalData(true, 'flag-admin');
			this.goTo('page-home');
		} catch (e) {
			if (e.status === 401) {
				if (e.data.message === 'Correo o password incorrecto.') {
					this.showError(e.data.message);
				}
			} else if (e.status === 500) {
				this.showError();
			} else if (e.status === 400) {
				if (e.data.email && e.data.password) {
					this.showError('El email y la contraseña son requeridos.');
				} else if (e.data.password) {
					this.showError('La contraseña es requerida.');
				} else if (e.data.email) {
					this.showError('El email es requerido.');
				}
			}
		} finally {
			this.isLoading = false;
		}
	}

	function data() {
		return {
			email: '',
			isLoading: false,
			password: '',
		};
	}

	export default {
		name: 'page-admin',
		created,
		data,
		methods: {
			login,
		},
	};
</script>

<style lang="scss" scoped>
	.page-login {
		background-image: url(http://picture-controlinn.s3.amazonaws.com/svg/section-top-back.jpg);
		background-position: center;
		background-size: cover;
		height: 100vh;
		width: 100vw;
	}

	.form-login {
		align-items: center;
		display: flex;
		flex-wrap: wrap;
		height: 100vh;
		justify-content: center;
	}

	.login {
		&-container {
			max-width: 300px;
		}
	}

	.mb-10 {
		margin-bottom: 10px;
	}

	.btn-blue {
		background-color: map-get($colors, background);
		border-radius: 5px;
		color: map-get($colors, white);
	}
</style>



// WEBPACK FOOTER //
// src/pages/page-admin.vue